<template>
    <div class="feature-box"  v-bind:style="{flexDirection: fDir}" :id="goToReference">

        <div class="feature-desc">
            <h2>{{title}}</h2>
            <p>{{description}}</p>
        </div>

        <img class="feature-img" :src="imagePath" :alt="altDesc">
    </div>
</template>


<script>
    export default {
        name: 'FeatureItem',

        props: {

            index: Number,
            title: String,
            description: String,
            imagePath: String,
            goToReference: String,
            altDesc: String,
        },

        mounted() {

            this.userIsDesktop = window.matchMedia('(min-width: 750px)').matches

            // Flips the order of the description and image
            if (this.index % 2 !== 0 && this.userIsDesktop){
                this.fDir = "row-reverse"

            } else if (this.index % 2 === 0 && this.userIsDesktop){
                this.fDir = "row"
            }
        },

        data: () => ({
            userIsDesktop: true,
            fDir: "column-reverse"
        }),
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

    .feature-box {

        height: 100vh;
        width: 100%;
        display: flex;

        align-items: center;
        justify-content: center;
    }

    .feature-img {
        width: 90%;
        margin-bottom: 4rem;

        /* https://gist.github.com/serglo/f9f0be9a66fd6755a0bda85f9c64e85f */
        box-shadow: 0 4px 5px 0 rgba(0,0,0,0.14), 0 1px 10px 0 rgba(0,0,0,0.12), 0 2px 4px -1px rgba(0,0,0,0.20);
    }

    h2 {
        text-align: center;
    }

    p {
        text-align: center;
    }

    @media screen and (min-width: 750px) {

        h2 {
            font-size: 40px;
        }

        p {
            font-size: 20px;
        }

        .feature-box {

            display: flex;
            padding: 20px;
            justify-content: space-between;
        }

        .feature-img {
            margin-bottom: 0;
            width: 50%;
        }

    }
</style>
